// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__LjQMM","header":"ReportDetails_header__2jvod","title":"ReportDetails_title__2UaAn","left":"ReportDetails_left__1Z4Yr"};